import { ReactElement } from 'react'

import { EInvoicingSetupContextProvider as PDPContextProvider } from '@features/eInvoicing/context/EInvoicingSetupContext'

import { EInvoicingNetworkKeys, EInvoicingNetworks } from './constants/EInvoicingNetworks'
import { NemHandelNetworkSettings } from './elements/networks/NemHandelNetworkSettings'
import { PDPNetworkSettings } from './elements/networks/PDPNetworkSettings'
import {
  EInvoicingSettingsComponent,
  EInvoicingSettingsContext,
  NullableEInvoicingSettings,
} from './elements/NullableEInvoicingSettings'
import { useEInvoicingSetups } from './hooks/useEInvoicingSetups'
import { NemHandelNetworkConfig, PDPNetworkConfig } from './types'

const EInvoicingSetupNetworkMap: Record<
  EInvoicingNetworkKeys,
  EInvoicingSettingsComponent<PDPNetworkConfig> | EInvoicingSettingsComponent<NemHandelNetworkConfig> | null
> = {
  [EInvoicingNetworks.PDP]: PDPNetworkSettings,
  [EInvoicingNetworks.NEMHANDEL]: NemHandelNetworkSettings,
}
interface EInvoicingSettingsProps {
  context: EInvoicingSettingsContext
}
const EInvoicingSettingsContent = ({ context }: EInvoicingSettingsProps) => {
  const networkSetups = useEInvoicingSetups()

  const nonNullNetworkSettings: ReactElement[] = Object.values(networkSetups)
    .filter((element): element is NonNullable<PDPNetworkConfig | NemHandelNetworkConfig> => !!element)
    .map((value) => {
      const component = EInvoicingSetupNetworkMap[value.networkType]
      const element = (
        <NullableEInvoicingSettings
          networkSettings={value}
          settingsComponent={component as unknown as EInvoicingSettingsComponent}
          context={context}
        />
      )
      return element
    })

  return nonNullNetworkSettings
}

export const EInvoicingSettings = ({ context = 'Purchase' }: EInvoicingSettingsProps) => {
  return (
    <PDPContextProvider>
      <EInvoicingSettingsContent context={context} />
    </PDPContextProvider>
  )
}
